module.exports = __webpack_public_path__ + "img/top-bg.7da0613b.jpg";